import type { Bank } from './types';

export function detectBank(text: string): Bank | 'unknown' {
  const head = text.slice(0, 4000).toLowerCase();
  if (head.includes('capitec bank statement')) return 'capitec';
  if (head.includes('tymebank') || head.includes('go-tyme') || head.includes('gotyme')) return 'tymebank';
  return 'unknown';
}
